import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_COMP_STATEMENT_RESULT } from "src/api-setup/api-endpoints";

/*
 * Earned vs projected totals per period - the bars on the Earnings Overview
 * chart. Ported from useSelectResult in the mobile app.
 *
 * Rows: { period_mstr_key, period_name, period_start_date, period_end_date,
 *         total_earned, total_projected, ... }
 */
export const getCompStatementResult = async (cookiesData, dispatch, providerId, periodTypeKey) => {
  if (!cookiesData || !providerId || !periodTypeKey) return [];

  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_provider_mstr_key: providerId,
      in_period_type_mstr_key: Number(periodTypeKey),
    };

    const response = await POSTAPI(false, GET_COMP_STATEMENT_RESULT, null, apiHeaders, requestBody, dispatch);
    const rowResult = response?.data?.row_result;

    return Array.isArray(rowResult) ? rowResult : [];
  } catch (error) {
    console.error("Error fetching comp statement result:", error);
    return [];
  }
};
